import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationEN from './locales/en.json';
import translationAR from './locales/ar.json';

const resources = {
  en: { translation: translationEN },
  ar: { translation: translationAR },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    keySeparator: false,
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

// Sync <html> dir/lang attributes globally so RTL is correct on first paint
// (e.g. Login page) and on every language change, regardless of which
// component is mounted. See AR-FIN finding RTL-FIN-001.
const syncDir = () => {
  if (typeof document === 'undefined') return;
  const lang = i18n.language || 'en';
  const isArabic = lang.startsWith('ar');
  document.documentElement.lang = lang;
  document.documentElement.dir = isArabic ? 'rtl' : 'ltr';
};
syncDir();
i18n.on('languageChanged', syncDir);

export default i18n;
